<template>
  <div class="flex justify-between dynamic1-wrapper">
    <div class="flex flex-col justify-between left">
      <img
        src="@/assets/images/logo-new2.png"
        alt=""
        class="title-image animate-fade-in"
      />
      <div class="desc animate-fade-in" :key="'dynamic1' + currentIndex">
        <p class="mb-4 font-extrabold text-title" v-if="data[0].title">
          {{ data[0].title }}
        </p>
        <p class="text-desc" v-if="data[0].desc">
          {{ data[0].desc }}
        </p>
      </div>
      <div class="mt-4 items-list">
        <a
          :href="item.href"
          target="_blank"
          class="flex justify-between block item animate-fade-in"
          v-for="(item, index) in data.slice(1)"
          :key="currentIndex + 'dynamic1' + index"
        >
          <div
            class="image swiper-image"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
          ></div>
          <!-- <img :src="item.image" alt="" /> -->
          <div class="flex-1 ml-4 mr-1">
            <p class="mb-2 font-extrabold text-title" v-if="item.title">
              {{ item.title }}
            </p>
            <p class="font-normal text-desc" v-if="item.desc">
              {{ item.desc }}
            </p>
          </div>
        </a>
      </div>
    </div>
    <a
      class="block right animate-fade-in swiper-image"
      :key="'dynamic1' + currentIndex"
      :href="data[0].href"
      target="_blank"
      :style="{ backgroundImage: 'url(' + data[0].image + ')' }"
    ></a>
  </div>
</template>

<script>
import AnimateLayout from '../../components/animate-layout'
export default {
  props: ['data', 'currentIndex'],
  watch: {
    currentIndex: {
      handler(val) {
        console.log('====dynamic1====' + val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="less">
@keyframes scaleTranslateXLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.dynamic1-wrapper {
  .animate-fade-in {
    animation: scaleTranslateXLeft 2s ease-in-out;
  }
  width: 90vw;
  margin: auto;
  margin-top: 5vh;
  height: 68vh;
  .text-title {
    font-size: 1.1vw;
  }
  .text-desc {
    font-size: 1vw;
  }
  .swiper-image {
    transition: background-size 0.3s ease-in-out;
    will-change: background-size;
    background-size: 100%;
    &:hover {
      background-size: 120%;
    }
  }
  .left {
    height: 100%;

    .title-image {
      width: 16vw;
      display: inline-block;
      margin: auto;
    }
    .desc {
      color: #333333;
    }
    .items-list {
      .item {
        margin-top: 1.5vh;

        .image {
          width: 15vw;
          height: 13.5vh;
          background-position: center;

          background-repeat: no-repeat;
        }
      }
    }
  }
  .right {
    width: 108vh;
    height: 100%;
    background-origin: center;
    background-position: center;
    background-repeat: no-repeat;
  }
}
</style>
